export const SHIFT_META = {
  R: { label: 'Ranná', short: 'R', bg: '#FEF3C7', text: '#92400E', border: '#FDE68A' },
  P: { label: 'Poobedná', short: 'P', bg: '#DBEAFE', text: '#1E40AF', border: '#BFDBFE' },
  M: { label: 'Medzizmena', short: 'M', bg: '#F3E8FF', text: '#6B21A8', border: '#E9D5FF' },
  C: { label: 'Celodenná', short: 'C', bg: '#FFE4E6', text: '#9F1239', border: '#FECDD3' },
  SO: { label: 'Sobota', short: 'So', bg: '#CCFBF1', text: '#115E59', border: '#99F6E4' },
  NE: { label: 'Nedeľa', short: 'Ne', bg: '#A7F3D0', text: '#065F46', border: '#6EE7B7' },
  X: { label: 'Voľno', short: 'X', bg: '#F8FAFC', text: '#94A3B8', border: '#E2E8F0' },
  D: { label: 'Dovolenka', short: 'D', bg: '#D1FAE5', text: '#065F46', border: '#A7F3D0' },
  '': { label: '—', short: '', bg: '#FFFFFF', text: '#CBD5E1', border: '#F1F5F9' },
};

export const ROLE_LABELS = {
  veduca: 'Vedúca',
  zastupca: 'Zástupkyňa',
  zamestnanec: 'Zamestnanec',
  brigadnik: 'Brigádnik',
};

export const ALL_CODES = ['R', 'P', 'M', 'C', 'SO', 'NE', 'X', 'D'];
export const WEEKDAY_CODES = ['R', 'P', 'M', 'C', 'X', 'D'];
export const WEEKEND_CODES = ['SO', 'NE', 'X', 'D'];
